/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  PostXmetadataSet200,
  PostXmetadataSetBody
} from './schema'



/**
 * Set xmetadata for a entity id and type. The value passed to xid or xmetadata will replace the existing xid or xmetadata values respectively.
To remove xid or xmetadata, pass in null value.

 * @summary Set xmetadata
 */
export const postXmetadataSet = (
    postXmetadataSetBody: PostXmetadataSetBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostXmetadataSet200>> => {
    return axios.post(
      `/xmetadata/set`,
      postXmetadataSetBody,options
    );
  }



    export type PostXmetadataSetMutationResult = NonNullable<Awaited<ReturnType<typeof postXmetadataSet>>>
    export type PostXmetadataSetMutationBody = PostXmetadataSetBody
    export type PostXmetadataSetMutationError = AxiosError<unknown>

    export const usePostXmetadataSet = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postXmetadataSet>>, TError,{data: PostXmetadataSetBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postXmetadataSet>>, {data: PostXmetadataSetBody}> = (props) => {
          const {data} = props ?? {};

          return  postXmetadataSet(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postXmetadataSet>>, TError, {data: PostXmetadataSetBody}, TContext>(mutationFn, mutationOptions)
    }
    